import { render, staticRenderFns } from "./CouponDetailAllTables.vue?vue&type=template&id=cba78092&"
import script from "./CouponDetailAllTables.vue?vue&type=script&lang=js&"
export * from "./CouponDetailAllTables.vue?vue&type=script&lang=js&"
import style0 from "./CouponDetailAllTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports